import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import * as _ from 'lodash';
import { HttpService } from "../../../../http.service";
import { UtilsService } from "../../../shared/services/utils.service";
import { apiURL, EnvConfig } from "../../../../env-config";

@Injectable()
export class LoggerService {
  constructor(
    private _http: HttpService,
    private _utilsService: UtilsService,
  ) { }

  getLogger(filter?: any): Observable<any> {
    let queryParams: string = !_.isEmpty(filter) ? '?' + this._utilsService.toQueryString(filter) : '';
    return this._http.get(`${apiURL(EnvConfig.API_LOGGER)}${queryParams}`);
  }

}